import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import {useTheme} from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, {memo, ReactNode} from 'react';

import {FooterComponent} from './footer.component';
import {NavigationComponent} from './navigation/navigation.component';
import {SidebarComponent} from './sidebar/sidebar.component';

interface LayoutProps {
  children: ReactNode;
}

function Layout({children}: LayoutProps) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{display: 'flex', minHeight: '100vh'}}>
      <CssBaseline />
      <NavigationComponent />
      {!mobileView && <SidebarComponent />}
      <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
        <Box component="main" sx={{flexGrow: 1}}>
          <Toolbar style={{height: mobileView ? '98px' : '118px'}} />
          {children}
        </Box>
        {!mobileView && <FooterComponent />}
      </div>
    </Box>
  );
}

export const LayoutComponent = memo(Layout);
